export default __webpack_public_path__ + "static/media/safe7-intro-hi.e3378f63.png";